export const fileStorageConstants = {
  UPLOAD_REQUEST: "UPLOAD_FILE_REQUEST",
  UPLOAD_SUCCESS: "UPLOAD_FILE_SUCCESS",
  UPLOAD_FAILURE: "UPLOAD_FILE_FAILURE",

  DELETE_REQUEST: "DELETE_FILE_REQUEST",
  DELETE_SUCCESS: "DELETE_FILE_SUCCESS",
  DELETE_FAILURE: "DELETE_FILE_FAILURE",
};
